module.exports = __webpack_public_path__ + "static/img/login_logo.8618baa8.png";